import React, { ReactElement, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import Player from "../../../components/LottiePlayer";
import lottieImg from "../../../assets/lottie/robot.lottie";
import { ErrorSecurity } from "../../error/Error";
import useRouting, { useParams } from "../../../contexts/Routing";

interface CreateAccountInput {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    companyName: string;
}

export default function CreateAccount(): ReactElement {
    const [accountInput, setAccountInput] = useState<CreateAccountInput>({
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        companyName: "",
    });
    const [errorMessage, setErrorMessage] = useState<string>();
    const { Paths, historyPush } = useRouting();
    const { inviteId } = useParams(Paths.ACCOUNT_CREATE_ID);

    // async function registerAndLogin(user: CreateAccountInput) {
    //     const { data } = await createAccount({
    //         variables: {
    //             id: inviteId,
    //             user,
    //         },
    //     });

    //     if (data?.acceptReferralAndLogin?.__typename === "LoginError") {
    //         const invalidResponse = data as LoginError;
    //         setErrorMessage(invalidResponse.message as string);
    //     } else {
    //         historyPush(Paths.HOME);
    //     }
    // }

    const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = evt.target;
        setAccountInput(data => ({
            ...data,
            [name]: value,
        }));
    };

    function handleSubmit(evt: React.FormEvent<HTMLFormElement>) {
        evt.preventDefault();
        // registerAndLogin(accountInput);
    }

    if (!inviteId) {
        return <ErrorSecurity message="Sorry we are currently an invite only service." />;
    }

    return (
        <div className="full-page">

            <div className="centered-container flex-row">
                <div
                    className={"flex-grow-0 w-50 align-self-center border-end pe-3 me-3 d-none "
                                + " d-lg-flex h-100 justify-content-center align-items-center"}

                >
                    <Player
                        autoplay
                        loop
                        src={lottieImg}
                        className="player"
                    />
                </div>
                <div className="flex-grow-1 flex-shrink-1 p-3">
                    <h3 className="my-4">Create your account</h3>
                    <form onSubmit={handleSubmit}>

                        <FloatingLabel
                            controlId="firstName"
                            label="First Name"
                            className="mb-3"
                        >
                            <Form.Control
                                type="text"
                                placeholder="Ada"
                                data-test="firstName"
                                name="firstName"
                                required
                                value={accountInput.firstName}
                                onChange={handleChange}
                            />
                        </FloatingLabel>
                        <FloatingLabel
                            controlId="lastName"
                            label="Last Name"
                            className="mb-3"
                        >
                            <Form.Control
                                type="text"
                                placeholder="Lovelace"
                                name="lastName"
                                data-test="lastName"
                                required
                                value={accountInput.lastName}
                                onChange={handleChange}
                            />
                        </FloatingLabel>

                        <FloatingLabel
                            controlId="email"
                            label="Email"
                            className="mb-3"
                        >
                            <Form.Control
                                type="email"
                                placeholder="ada@example.com"
                                data-test="email"
                                value={accountInput.email}
                                name="email"
                                required
                                isInvalid={errorMessage != null ? true : undefined}
                                onChange={handleChange}
                            />
                            {errorMessage && (
                                <Form.Control.Feedback type="invalid" className="mt-2">
                                    {errorMessage}
                                </Form.Control.Feedback>
                            )}
                        </FloatingLabel>

                        <FloatingLabel
                            controlId="password"
                            label="Password"
                            className="mb-3"
                        >
                            <Form.Control
                                type="password"
                                data-test="password"
                                placeholder="Password"
                                name="password"
                                required
                                value={accountInput.password}
                                onChange={handleChange}
                            />
                        </FloatingLabel>

                        <FloatingLabel
                            controlId="company"
                            label="Company"
                            className="mb-3"
                        >
                            <Form.Control
                                type="text"
                                data-test="company"
                                placeholder="Company Name"
                                name="companyName"
                                required
                                value={accountInput.companyName}
                                onChange={handleChange}
                            />
                        </FloatingLabel>

                        <div className="d-flex justify-content-between align-items-center mt-4">
                            <div>
                                <small id="emailHelp" className="form-text text-muted mt-2">
                                    By clicking Register, you agree to our
                                    {" "}
                                    <a href="https://www.foqal.io/policies/terms-of-service">
                                        Terms of Service
                                    </a>
                                    {" "}
                                    and
                                    {" "}
                                    <a href="https://www.foqal.io/policies/privacy-policy">
                                        Privacy Policy.

                                    </a>
                                </small>
                            </div>
                            <button data-test="register" type="submit" className="btn btn-primary">
                                Register
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
